import { motion, useMotionValue, useTransform } from 'framer-motion';
import * as React from 'react';

import styled from 'styled-components';

interface CurvedArrowProps {
  className?: string;
}

const CurvedArrow: React.FC<CurvedArrowProps> = (props) => {
  const pathLength = useMotionValue(0);
  const opacity = useTransform(pathLength, [0.05, 0.15], [0, 1]);

  const path = {
    hidden: {
      pathLength: 0,
    },
    visible: {
      pathLength: 1,
      transition: {
        duration: 4,
        type: 'spring',
        stiffness: 50,
      },
    },
  };
  return (
    <svg
      className={`${props.className || ''}`}
      width="52.2"
      height="126"
      viewBox="0 0 52.2 126"
    >
      <Path
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeLinejoin="round"
        fill="none"
        initial={'hidden'}
        animate={'visible'}
        exit={'hidden'}
        variants={path}
        style={{ pathLength: pathLength, opacity: opacity }}
        d="M37 0.5C23.7 11 9 21 3.4 37.6c-2.8 8.3-3.2 16.8-2.8 25.4 0.4 9.1 2.6 17.9 6.9 25.9 2.8 5.3 6.4 10.3 11.1 14 4.5 3.5 9.2 6.3 14.3 8.7 4.6 2.2 9.3 4.5 14.1 6.3 1.4 0.5 1.7 0.7 1.2-1.1 -0.8-2.7-1.7-5.5-2.8-8.1 -1-2.6-4.3-10.2-3-7.8 1.4 2.5 2.9 5 4.4 7.5 1.5 2.6 3.6 5.1 4.8 7.8 0.1 0.3 0.1 1.1 0 1.3 -0.6 1.1-3.7 1.8-4.7 2.2 -2.6 1-5.2 2-7.8 3.1 -1.6 0.7-3.4 1.5-4.8 2.6"
      />
    </svg>
  );
};

export default styled(CurvedArrow)``;

const Path = styled(motion.path)`
  opacity: 0.3;
  stroke: ${({ theme }) => theme.colors.primary};
`;
